import { PercentileRankingsChartConfigDto, PercentileRankingsChartDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import PercentileRankings from 'components/PercentileRankings/PercentileRankings';
import { getDisplayedColumns } from 'utilities/tableHeaders';
import { useMemo } from 'react';

const PercentileRankingsChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<PercentileRankingsChartDto, PercentileRankingsChartConfigDto>) => {
  const displayKeys = getDisplayedColumns<string>(extraChartData.visibleStats);
  const viewDataAs = useMemo(() => extraChartData.viewDataAs, [extraChartData.viewDataAs]);
  return <PercentileRankings chartData={chartData} isLoading={isLoading} displayKeys={displayKeys} viewDataAs={viewDataAs} />;
};

export default PercentileRankingsChart;
